import React from 'react'

import { ConnectionsModalContext } from './ConnectionsModalContext'
import { connectionsModalReducer } from './connectionsModalReducer'
import { ConnectionsModalState, ConnectionsModalActionTypes } from 'interfaces'
interface Props {
  children: React.ReactNode
}
const ConnectionsModal_INITAL_SATATE: ConnectionsModalState = {
  isOpen: false,
}
export const ConnectionsModalProvider: React.FC<Props> = ({ children }) => {
  const [state, dispatch] = React.useReducer(
    connectionsModalReducer,
    ConnectionsModal_INITAL_SATATE
  )

  const toggleConnectionsModal = () => {
    dispatch({
      type: ConnectionsModalActionTypes.TOGGLE_MODAL,
    })
  }

  return (
    <ConnectionsModalContext.Provider
      value={{
        ...state,
        toggleModal: toggleConnectionsModal,
      }}
    >
      {children}
    </ConnectionsModalContext.Provider>
  )
}
